import React from 'react'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { isAppLoading } from '../../../app/selectors'
import { LatestUpdatesContainer, MonthYear, StateList, StateName, UpdateCounter } from './styles'
import { GraphHeading } from '../../../theme/Global'
import { StatesAndProvincesText } from '../styles'
import APILoadingSpinnerRenderer from '../../../app/components/apiLoadingSpinner'


const LatestUpdatesWidget = () => {
  const isLoading = useSelector(isAppLoading)
  const updates = useSelector((state) => Object.values(state.compliance.updates))
  const updatesCheck = updates && updates.length > 0

  const getLatestUpdate = () => {
    return updates.reduce((a, b) => (new Date(a.gridMonth) > new Date(b.gridMonth) ? a : b))
  }

  const latestUpdate = updatesCheck ? getLatestUpdate() : null
  const mandatoryUpdates = updatesCheck && latestUpdate.mandatoryUpdates.length > 0 ? latestUpdate.mandatoryUpdates.split(',') : []
  const updateDate = updatesCheck ? dayjs(latestUpdate.gridMonth).format('MMMM YYYY') : null

  return (
    <LatestUpdatesContainer>
      <GraphHeading>
        Latest Updates
      </GraphHeading>
      {isLoading ? (
        <APILoadingSpinnerRenderer />
      ) : (
        <React.Fragment>
          <Link
            href="/compliance/updates"
            to="/compliance/updates"
            style={{ textDecoration: 'none' }}
          >
            <UpdateCounter>
              {mandatoryUpdates.length}
            </UpdateCounter>
          </Link>
          <StatesAndProvincesText>
            States and Provinces
          </StatesAndProvincesText>
          <StateList>
            {mandatoryUpdates && mandatoryUpdates.map((state, index) => (
              <StateName key={state}>
                {state}{index !== mandatoryUpdates.length - 1 ? ',' : ''}
              </StateName>
            ))}
          </StateList>
          <MonthYear>
            {updateDate} 
          </MonthYear>
        </React.Fragment>
      )}
    </LatestUpdatesContainer>
  )
}

export default LatestUpdatesWidget
